export default "__VITE_ASSET__CevJUbIP__"